export default {
  username: 'Nombre de usuario',
  password: 'Contraseña',
  checkPass: 'Confirmar contraseña',
  confirm_password: 'Confirmar contraseña',
  add_user: 'Añadir usuario',
  modify_pwd: 'Modificar contraseña',
  modify_withdraw_type: 'Modificar método de retiro',
  reset_password: 'Restablecer contraseña',
  pay_password_setting: 'Configuración de contraseña de pago',
  second_after_regain: ' segundos para volver a solicitar',
  verify: 'Verificar',
  send_verification_code: 'Enviar código de verificación',
  verification_code: 'Código de verificación:',
  login_email: 'Correo electrónico de inicio de sesión',
  authorized: 'Permisos de acceso',
  authorized_status: 'Estado de activación',
  authority: 'Permisos',
  role: 'Rol',
  modify_auth: 'Modificar permisos',
  assign_role: 'Asignar rol',
  modify_role: 'Editar rol',
  mch_order_id: 'ID único de identificación del comercio',
  payout_mch_order_id: 'ID de orden del comercio',
  amount: 'Monto de pago',
  channel_code: 'Canal de pago',
  payout_status: 'Estado del desembolso',
  refund_method: 'Método de reembolso',
  contact_details: 'Información de contacto',
  customerService_email: 'Correo de atención al cliente',
  customerService_phone_number: 'Teléfono de atención al cliente',
  payment_amount_cents_tips: 'Monto de cobro en centavos. Ej. para {currency}: 500.10, debe ingresar 50010 centavos',
  payment_amount_peso_tips: 'Monto de cobro en pesos. Ej. para {currency}: 500.10, debe ingresar 500.1 pesos',
  payment_amount_tips: 'Monto de cobro en centavos. Ej. para {currency}: 500.10, debe ingresar 50010 centavos',
  payment_amount_tips_id: 'Monto de cobro en la moneda local. Ej. para {currency}: 50010, debe ingresar 50010',
  reset_mfa: 'Restablecer MFA',
  mfa_verify_code: 'Código de verificación MFA',
  mfa_status: 'Estado MFA',
  remark: 'Nota / Comentario',
  role_name: 'Nombre del rol',
  add_role: 'Añadir nuevo rol',
  user_authentication: 'Autenticación de usuario',
  role_details: 'Detalles del rol',
  permissions: 'Permisos',
  account_details: 'Detalles de la cuenta',
  password_details: 'Detalles de la contraseña',
  change_your_password: 'Cambiar su contraseña',
  change_bank_info: 'Cambiar información bancaria',
  change_withdraw_info: 'Cambiar información de retiro',
  edit_bank: 'Editar información bancaria',
  bank_details: 'Detalles del banco',
  withdraw_details: 'Detalles del retiro',
  copy_bank_passbook_wallet: 'Primera página de la cartilla / Billetera',
  business_permit: 'Adjunto de registro comercial',
  bir_registraon: 'Adjunto de registro fiscal (BIR / RFC)',
  certificate_authorized_representative: 'Firma del representante autorizado',
  article_of_incorporation: 'Acta constitutiva',
  withdraw_type: 'Tipo de retiro',
  auto_withdraw_type: 'Método de retiro automático',
  reviewing: 'En revisión',
  activated: 'Activado',
  reject: 'Rechazar',
  dismiss: 'Descartar',
  dismiss_reason: 'Motivo del rechazo',
  the_next_day: 'Día siguiente',
  handling_fee: 'Comisión de procesamiento',
  per_transaction: 'por transacción',
  update_role: 'Actualizar rol',
  kyc_unverified: 'No verificado',
  kyc_pending: 'Verificación en proceso',
  kyc_verified: 'Verificado',
  kyc_rejected: 'Revisión rechazada',
  notification_config: 'Configuración de notificaciones',
  config: 'Configuración',
  trade_daily_report_notification: 'Notificación de reporte diario de transacciones',
  send_trade_daily_notification: 'Enviar reporte diario de transacciones a una hora fija todos los días',
  scheduled_send: 'Envío programado',
  send_time: 'Hora de envío',
  send_test_email: 'Enviar correo de prueba',
  balance_alert_notification: 'Notificación de alerta de saldo mínimo',
  balance_alert_description: 'Enviar una notificación cuando el saldo sea inferior al monto configurado',
  event_trigger: 'Disparador de evento',
  alert_amount: 'Monto de alerta',
  add_alert_amount: 'Añadir monto de alerta',
  email_notification: 'Notificación por correo electrónico',
  receive_notification: 'Notificaciones en la aplicación:',
  send_test_notification: 'Enviar notificación de prueba',
  warn_amount: 'Importe de la alerta',
  warn_amount_placeholder: 'Introduce el importe de la alerta',
  warn_amount_invalid: 'Introduce un importe de alerta válido',
  warn_amount_exists: 'Este importe de alerta ya existe',
  warn_amount_duplicate: 'No se permiten importes de alerta duplicados',
  warn_amount_min_error: 'El importe debe ser mayor que 0',
  warn_amount_max_error: 'El importe no puede superar 999.999.999.999',
  add: 'Agregar',
  add_warn_amount: 'Agregar importe de alerta',
  save: 'Guardar',
  cancel: 'Cancelar'
}
